module.exports = "/_next/static/images/LandscapeMobile-a8c667d57944d6af759fbcef7fa740a3.png";